module.exports = __webpack_public_path__ + "img/28.74b7cc73.jpeg";